export const RADIUSVALUES = {
  large: [{
    label: '0m',
    value: '0',
  },
  {
    label: '500m',
    value: '500',
  },
  {
    label: '1km',
    value: '1000',
  },
  {
    label: '3km',
    value: '3000',
  }],
  small: [{
    label: '0m',
    value: '0',
  },
  {
    label: '200m',
    value: '200',
  },
  {
    label: '500m',
    value: '500',
  },
  {
    label: '1km',
    value: '1000',
  }],
};
